export class ImageLoader<K extends string> {
  private images = new Map<K, {
    img: HTMLImageElement;
    width: number;
    height: number;
  }>();

  async load(key: K, src: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        this.images.set(key, {
          img,
          width: img.width,
          height: img.height
        });
        resolve();
      };
      img.onerror = reject;
      img.src = src;
    });
  }

  get(key: K) {
    const data = this.images.get(key);
    if (!data) {
      throw new Error(`Image "${key}" not loaded`);
    }
    return data;
  }
}
